// extracted by mini-css-extract-plugin
module.exports = {"container":"CatalogItemInfo_container__47RCR","wrapper":"CatalogItemInfo_wrapper__1SfYv","title":"CatalogItemInfo_title__2mn3C","text":"CatalogItemInfo_text__3WdXC"};